import React from 'react';
import { Header } from './components/Header';
import { PostCardImage } from './images/PostCardImage';
import { LogoSmilesSmallImage } from './images/LogoSmilesSmallImage';
import { ArrowRight } from './images/ArrowRight';
import { LogoGolSmallImage } from './images/LogoGolSmallImage';
import { redirectToGolDefault } from './utils/partnerRedirect';

export function RedoRegisterTangieSuccess() {
  const handleGolClick = () => {
    const golUrl = redirectToGolDefault();

    window.location.href = golUrl;
  };

  const handleSmilesClick = () => {
    window.location.href = `${window.location.origin}/home?upd=${new Date().getTime()}`;
  };

  return (
    <main className="first-access-container redo-register-v2-success gol-sans" data-testid="first-access-main">
      <Header />
      <div className="redo-register-v2-section">
        <div className="redo-register-v2-content" style={{ maxWidth: '438px', paddingTop: '6rem' }}>
          <div style={{ marginBottom: '2.5rem' }}>
            <PostCardImage />
          </div>
          <p className="title">Vamos analisar seus dados!</p>
          <p className="subtitle">
            Você vai receber um e-mail assim que a análise for concluída. Enquanto isso, que tal conferir as nossas
            plataformas e explorar um mundo de opções para sua próxima viagem?
          </p>
          <div>
            <div className="redo-register-v2-redirect-button" onClick={handleSmilesClick}>
              <LogoSmilesSmallImage />
              <p style={{ marginBottom: '0', flexGrow: '1' }}>Ir para a Smiles</p>
              <ArrowRight />
            </div>

            <div style={{ width: '100%', borderBottom: '1.5px solid #EBE6E1' }} />

            <div className="redo-register-v2-redirect-button" onClick={handleGolClick}>
              <LogoGolSmallImage />
              <p style={{ marginBottom: '0', flexGrow: '1' }}>Ir para a GOL</p>
              <ArrowRight />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
